import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../Component/Sidebar";
import TopBar from "../../Component/TopBar";
import "./index.css";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { Calendar, Radio, Select, theme, Typography } from "antd";
import moment from "moment";
import dayLocaleData from "dayjs/plugin/localeData";
import CalenderData from "./CalenderData";
dayjs.extend(dayLocaleData);
export default function Index() {
  const { token } = theme.useToken();
  const [date, setDate] = useState(moment().format("DD-MM-YYYY"));
  const onPanelChange = (value, mode) => {
    console.log(value.format("YYYY-MM-DD"), mode);
    setDate(value.format("YYYY-MM-DD"));
  };
  return (
    <Container fluid className="parent-container">
      <Row>
        <Col md={2}>
          <Sidebar />
        </Col>
        <Col
          md={10}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Container className="calender-box">
            <Row>
              <Col md={5} className="calender-holder">
                <Calendar
                  fullscreen={false}
                  onPanelChange={onPanelChange}
                  style={{ width: "70%" }}
                />
              </Col>
              <Col md={7}>
                <CalenderData date={date} />
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}
